export enum ListGridOrderType {
  Ascending = 'asc',
  Descending = 'desc'
}
